module.exports = __webpack_public_path__ + "media/20dNew.a34cb95c.mp4";